import { createSlice } from '@reduxjs/toolkit';

// Type
const initialState = {
  selectedProviderData: {},
  selectedCurrency: {},
  showCurrencyModal: false,
  showDeleteProviderModal: false,
  showProviderDrawer: false,
  showCancelProviderDrawer: false,
};

const providerDrawerSlice = createSlice({
  name: 'providerDrawer',
  initialState,
  reducers: {
    setShowProviderDrawer: (state, { payload }) => {
      state.showProviderDrawer = payload;
    },
    setShowDeleteProviderModal: (state, { payload }) => {
      state.showDeleteProviderModal = payload;
    },
    setShowCancelProviderDrawer: (state, { payload }) => {
      state.showCancelProviderDrawer = payload;
    },
    setSelectedProvider: (state, { payload }) => {
      state.selectedProviderData = payload;
    },
    setSelectedCurrency: (state, { payload }) => {
      state.selectedCurrency = payload;
    },
    setShowCurrencyModal: (state, { payload }) => {
      state.showCurrencyModal = payload;
    },
  },
  extraReducers: {},
});

export const { reducer: providerDrawerReducer } = providerDrawerSlice;
export const {
  setShowProviderDrawer,
  setShowCancelProviderDrawer,
  setSelectedProvider,
  setShowDeleteProviderModal,
  setSelectedCurrency,
  setShowCurrencyModal,
} = providerDrawerSlice.actions;
